const INFO = {
	main: {
		email: "namesuz41@gmail.com",
		logo: "../logo.png",
		name: "Qodirkhan.",
	},

	socials: {
		telegram: "https://t.me/behissiyot",
		github: "https://github.com/Qodirxon2000a",
		instagram: "https://instagram.com/nodirkhanovvv",
		facebook: "https://facebook.com/exp_master",
	},

	projects: [
		{
			logo: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/electron/electron-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
			],
			link: "https://navbat.nodirkhanov.uz",
		},
		{
			logo: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
			],
			link: "https://t.me/uzbstarsbuybot",
		},
		{
			logo: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
			],
			link: "https://t.me/milliydokonbot",
		},
	],
};

export default INFO;
